var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.828,
    height: 42.006,
    viewBox: "0 0 34.828 42.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XLS",
    transform: "translate(0 2.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4568",
    "data-name": "Path 4568",
    d: "M42.712,14.5H33.427V4.75A.733.733,0,0,0,32.713,4h-20A.733.733,0,0,0,12,4.75v40.5a.733.733,0,0,0,.714.75h30a.733.733,0,0,0,.714-.75v-30A.733.733,0,0,0,42.712,14.5Z",
    transform: "translate(-8.602 -6)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6121",
    "data-name": "Rectangle 6121",
    width: 25.536,
    height: 13.75,
    rx: 1,
    transform: "translate(0 19.995)",
    fill: "#2e7d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4569",
    "data-name": "Path 4569",
    d: "M51.221,14.2l-10-10A.714.714,0,0,0,40,4.713v10a.714.714,0,0,0,.714.714h10a.714.714,0,0,0,.507-1.221Z",
    transform: "translate(-16.604 -5.998)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4571",
    "data-name": "Path 4571",
    d: "M2.713-2.127,3.862-4.24H5.314L3.529-1.2,5.361,1.89H3.891L2.713-.257,1.534,1.89H.064L1.9-1.2.111-4.24H1.563Zm5.409,3H10.8V1.89H6.858V-4.24H8.121ZM15.568.281a.846.846,0,0,0-.046-.288.559.559,0,0,0-.179-.238,1.637,1.637,0,0,0-.366-.215,5.775,5.775,0,0,0-.6-.223,7.406,7.406,0,0,1-.794-.3,2.92,2.92,0,0,1-.653-.4,1.774,1.774,0,0,1-.442-.528,1.444,1.444,0,0,1-.162-.7,1.489,1.489,0,0,1,.166-.7,1.58,1.58,0,0,1,.467-.541,2.3,2.3,0,0,1,.716-.347,3.167,3.167,0,0,1,.911-.124,2.877,2.877,0,0,1,.926.141,2.127,2.127,0,0,1,.711.394,1.742,1.742,0,0,1,.455.6,1.794,1.794,0,0,1,.16.76H15.572a1.019,1.019,0,0,0-.061-.358.727.727,0,0,0-.187-.282.871.871,0,0,0-.316-.183,1.372,1.372,0,0,0-.446-.065,1.515,1.515,0,0,0-.432.055.877.877,0,0,0-.3.152.638.638,0,0,0-.181.227.648.648,0,0,0-.061.278.6.6,0,0,0,.309.507,3.5,3.5,0,0,0,.907.381,5.966,5.966,0,0,1,.882.345,2.622,2.622,0,0,1,.636.429A1.638,1.638,0,0,1,16.7-.4a1.678,1.678,0,0,1,.131.678,1.588,1.588,0,0,1-.158.72,1.488,1.488,0,0,1-.448.533,2.123,2.123,0,0,1-.7.333,3.37,3.37,0,0,1-.916.116,3.538,3.538,0,0,1-.606-.053,2.917,2.917,0,0,1-.579-.162,2.515,2.515,0,0,1-.512-.274,1.889,1.889,0,0,1-.41-.387,1.748,1.748,0,0,1-.274-.507,1.9,1.9,0,0,1-.1-.629H13.4a1.131,1.131,0,0,0,.088.472.806.806,0,0,0,.246.314,1.025,1.025,0,0,0,.381.175,2.087,2.087,0,0,0,.5.055,1.531,1.531,0,0,0,.425-.053.874.874,0,0,0,.3-.145.575.575,0,0,0,.175-.221A.674.674,0,0,0,15.568.281Z",
    transform: "translate(4.168 28.045)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.053ce68314ce61258eca31315cec5cd4.svg";
export { ForwardRef as ReactComponent };